import { createSlice } from "@reduxjs/toolkit";

const dataSlice = createSlice({
  name: "data",
  initialState: {
    home: null,
    tamima: null,
    social: null,
    character: null,
    blog: null,
    roadmap: null,
    whitepaper: null,
  },
  reducers: {
    set_HomeData: (state, action) => {
      state.home = action.payload;
    },
    set_TamimaData: (state, action) => {
      state.tamima = action.payload;
    },
    set_SocialData: (state, action) => {
      state.social = action.payload;
    },
    set_CharacterData: (state, action) => {
      state.character = action.payload;
    },
    set_BlogData: (state, action) => {
      state.blog = action.payload;
    },
    set_RoadmapData: (state, action) => {
      state.roadmap = action.payload;
    },
    set_WhitepaperData: (state, action) => {
      state.whitepaper = action.payload;
    },
  },
});

export const {
  set_HomeData,
  set_TamimaData,
  set_SocialData,
  set_CharacterData,
  set_BlogData,
  set_RoadmapData,
  set_WhitepaperData,
} = dataSlice.actions;

export default dataSlice.reducer;
